var map = {
	"./HEAD1.svg": 38795,
	"./HEAD10.svg": 49765,
	"./HEAD11.svg": 35685,
	"./HEAD12.svg": 37029,
	"./HEAD2.svg": 53871,
	"./HEAD3.svg": 68801,
	"./HEAD4.svg": 60895,
	"./HEAD5.svg": 50396,
	"./HEAD6.svg": 37047,
	"./HEAD7.svg": 37062,
	"./HEAD8.svg": 18672,
	"./HEAD9.svg": 22875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49087;